import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var ReadOnlyMap =
/*#__PURE__*/
function () {
  function ReadOnlyMap(parameters) {
    _classCallCheck(this, ReadOnlyMap);

    this._map = new Map(parameters);
  }

  _createClass(ReadOnlyMap, [{
    key: "entries",
    value: function entries() {
      return this._map.entries();
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      var _this = this;

      var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this._map.forEach(function (value, key) {
        return callback.call(thisArg, value, key, _this);
      });
    }
  }, {
    key: "get",
    value: function get(name) {
      return this._map.get(name);
    }
  }, {
    key: "has",
    value: function has(name) {
      return this._map.has(name);
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._map.keys();
    }
  }, {
    key: "values",
    value: function values() {
      return this._map.values();
    }
  }, {
    key: "size",
    get: function get() {
      return this._map.size;
    }
  }]);

  return ReadOnlyMap;
}();